// main.js
import "./style.css";
import "./backup.css";
import "./polyfills";
import { Game } from "./core/Game.js";
import { SceneTransition } from "./core/SceneTransition.js";
import { GameState } from "./core/GameState.js";
import { mountCivicAuth } from "./utils/CivicAuthMount.jsx";
// import { authIntegration } from "./utils/auth-integration.js";

// PWA-specific initialization
function initPWAFeatures() {
  // Check if launched as PWA
  GameState.isPWA = window.matchMedia("(display-mode: standalone)").matches;

  // Handle offline state
  window.addEventListener("offline", () => {
    GameState.networkStatus = "offline";
    console.warn("Network connection lost");
  });

  window.addEventListener("online", () => {
    GameState.networkStatus = "online";
    console.log("Network connection restored");
  });
}

const game = new Game();
GameState.game = game;
// GameState.auth = authIntegration;

window.onload = async () => {
  initPWAFeatures();

  try {
    const civicContainer = document.createElement("div");
    civicContainer.id = "flex-buttons";
    document.body.appendChild(civicContainer);
    mountCivicAuth("flex-buttons", import.meta.env.VITE_CIVIC_CLIENT_ID);
    const flexButtons = document.getElementById("flex-buttons");
    if (flexButtons) {
      flexButtons.classList.add("hidden"); // Hide by default
    }
  } catch (err) {
    console.error("[CivicAuth] Could not mount Civic UI:", err.message);
  }

  // Initialize auth system
  // await authIntegration.init();

  await SceneTransition.fadeOut(500);
  game.init();

  // Add auth button to your UI
  // addAuthButtonToUI();

  // Lock orientation for mobile
  if (screen.orientation && screen.orientation.lock) {
    try {
      await screen.orientation.lock("landscape");
    } catch (err) {
      console.warn("Orientation lock failed:", err);
    }
  }
};

window.onbeforeunload = () => {
  SceneTransition.fadeIn(500);

  // Clean up Three.js resources
  if (GameState.scene) {
    GameState.scene.traverse((obj) => {
      if (obj.isMesh) {
        if (obj.geometry) obj.geometry.dispose();
        if (obj.material) {
          if (Array.isArray(obj.material)) {
            obj.material.forEach((m) => m.dispose());
          } else {
            obj.material.dispose();
          }
        }
      }
    });
  }

  if (GameState.renderer) {
    GameState.renderer.dispose();
  }
};
